import PanToolAltIcon from "@mui/icons-material/PanToolAlt";
import {
  getDownloadURL,
  ref as stgRef,
  uploadBytesResumable,
} from "firebase/storage";
import { db, storage } from "../../../../firebaseConfig";
import { ref, set } from "firebase/database";
import { useState } from "react";
import "./EditTherapistBio.css";

export default function EditTherapistBio({
  bioTextUpdate,
  therapistData,
  setIsEditBio,
  setBioTextUpdate,
}) {
  const [therapistPhoto, setTherapistphoto] = useState(null);
  const [progress, setProgress] = useState(0);
  const [name, setName] = useState(therapistData?.displayName || "");

  const [isSigningIn, setIsSigningIn] = useState(false);

  const handleBioData = async () => {
    if (bioTextUpdate.length > 0) {
      setIsSigningIn(true);
      if (therapistPhoto) {
        console.log("YES IMAGE");
        const response = await fetch(therapistPhoto);
        const blob = await response.blob();
        const photoFileName = `therapist_photo_${therapistData?.uid}.jpg`;
        const photoRef = stgRef(storage, `therapist_photos/${photoFileName}`);
        const uploadTask = uploadBytesResumable(photoRef, blob);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress_ = snapshot.bytesTransferred / snapshot.totalBytes;
            setProgress((progress_ * 100).toFixed());
            // console.log(progress_);
          },
          (error) => {
            // handle error
            alert("Ooops, there was a problem uploading your photo");
            console.log(error);
            console.error("Upload error:", error);
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref)
              .then(async (downloadURL) => {
                // console.log(downloadURL);
                // Update display name in Firebase Realtime Database
                const userRef = ref(db, `therapists/${therapistData?.uid}`);
                const updatedUser = {
                  ...therapistData,
                  photoURL: downloadURL,
                  bio: bioTextUpdate,
                  displayName: name,
                };

                await set(userRef, updatedUser);

                setIsEditBio(false);

                setIsSigningIn(false);
              })
              .catch((error) => {
                alert("Error getting download URL: ", error);
                console.error("Error getting download URL:", error);
              });
          }
        );
      } else {
        try {
          // Update display name in Firebase Realtime Database
          const userRef = ref(db, `therapists/${therapistData?.uid}`);
          const updatedUser = {
            ...therapistData,
            bio: bioTextUpdate,
            displayName: name,
          };
          await set(userRef, updatedUser);

          setIsEditBio(false);
          setIsSigningIn(false);

          console.log("saved");
        } catch (error) {
          // Handle the error, e.g., log it or show an error message to the user?.
          alert("Oops, a problem occurred");
          console.error("Error updating name:", error);
        }
      }
    } else {
      alert("You must type your bio to update!!");
    }
  };
  return (
    <div className="edit-therapist">
      <div className="add-therapist-container">
        {therapistPhoto || therapistData?.photoURL ? (
          <img
            src={therapistPhoto || therapistData?.photoURL}
            className="profile-img"
            alt={`${therapistData?.displayName}`}
          />
        ) : (
          <div className="profile-div">
            <h3 style={{ color: "#d3d3d3", textAlign: "center" }}>
              Click below to upload a photo
            </h3>
            <PanToolAltIcon
              style={{
                color: "#d3d3d3",
                fontSize: 42,
                transform: "rotate(180deg)",
              }}
            />
          </div>
        )}
        <input
          className="add-profile"
          type="file"
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) {
              const reader = new FileReader();
              reader.onloadend = () => {
                setTherapistphoto(reader.result);
              };
              reader.readAsDataURL(file);
            }
          }}
        />
        <input
          placeholder="Therapist's full name"
          value={name}
          type={"text"}
          onChange={(e) => setName(e.target.value)}
        />

        <textarea
          placeholder="Therapist's bio"
          value={bioTextUpdate}
          rows={8}
          onChange={(e) => setBioTextUpdate(e.target.value)}
        ></textarea>

        <button
          className="submit-btn"
          style={isSigningIn ? { backgroundColor: "#071c2e6b" } : {}}
          disabled={isSigningIn}
          onClick={() => handleBioData()}
        >
          {isSigningIn ? `Saving updates ${progress}%...` : "Save Updates"}
        </button>
        {!isSigningIn && (
          <button className="cancel-btn" onClick={() => setIsEditBio(false)}>
            Cancel Edits
          </button>
        )}
      </div>
    </div>
  );
}
